export default __webpack_public_path__ + "static/ProzaLibre-Bold-847e4ccf16036b7bd7b15265b8675e1e.ttf";